import * as React from 'react';
import { useTranslation, WithTranslation, withTranslation } from 'react-i18next';
import { MultipleSelectionDropdownOptions } from 'widgets/editors/multiple-selection-dropdown';
import { EventStatus } from 'stores/events/events-store';
import { IdentityService } from 'services/identity-service';
import { container } from 'inversify.config';
import { useState } from 'react';
import TailwindMultiSelect from 'widgets/editors/tailwind-multiselect';

interface TailwindMultipleEventStatusEditorProps extends WithTranslation {
  value: EventStatus[];
  onChange?: (value: EventStatus[]) => void;
  placeholder?: string;
  clearable?: boolean;
  className?: string;
  statusFilterActive?: boolean;
  onBlur?: (event: any) => void;
  onFocus?: (event: any) => void;
  requestedFromScheduler?: boolean;
  disabled?: boolean;
}

const TailwindMultipleEventStatusEditor: React.FC<TailwindMultipleEventStatusEditorProps> = ({
  value,
  onChange,
  placeholder,
  clearable,
  className,
  statusFilterActive,
  onBlur,
  onFocus,
  requestedFromScheduler,
  disabled
}) => {
  const { t } = useTranslation();
  const identityService: IdentityService = container.get(IdentityService);
  const currentUserInfo = identityService.getUserInfo();

  const getAllEventStatus = () => {
    let map: { id: string; text: string; value: string }[] = [];

    if (!requestedFromScheduler) {
      for (let n in EventStatus) {
        if (typeof EventStatus[n] === 'number') {
          if (statusFilterActive) {
            if (IdentityService.isPoc(currentUserInfo)) {
              if (
                EventStatus[n].toString() === '10' ||
                EventStatus[n].toString() === '20' ||
                EventStatus[n].toString() === '30' ||
                EventStatus[n].toString() === '40'
              ) {
                map.push({ id: EventStatus[n], text: n, value: EventStatus[n] });
              }
            } else if (IdentityService.isPlannerMTC(currentUserInfo)) {
              if (EventStatus[n].toString() === '10') {
                map.push({ id: EventStatus[n], text: n, value: EventStatus[n] });
              }
            } else {
              if (
                EventStatus[n].toString() === '10' ||
                EventStatus[n].toString() === '20' ||
                EventStatus[n].toString() === '30' ||
                EventStatus[n].toString() === '40'
              ) {
                map.push({ id: EventStatus[n], text: n, value: EventStatus[n] });
              }
            }
          } else {
            if (IdentityService.isPlannerMTC(currentUserInfo)) {
              if (
                EventStatus[n].toString() === '50' ||
                EventStatus[n].toString() === '20' ||
                EventStatus[n].toString() === '30' ||
                EventStatus[n].toString() === '40'
              ) {
                map.push({ id: EventStatus[n], text: n, value: EventStatus[n] });
              }
            } else {
              if (EventStatus[n].toString() === '50') {
                map.push({ id: EventStatus[n], text: n, value: EventStatus[n] });
              }
            }
          }
        }
      }
    }

    if (requestedFromScheduler) {
      for (let n in EventStatus) {
        if (typeof EventStatus[n] === 'number') {
          map.push({ id: EventStatus[n], text: n, value: EventStatus[n] });
        }
      }
    }

    return map.sort((a, b) => {
      if (a.text.toLowerCase() < b.text.toLowerCase()) return -1;
      if (a.text.toLowerCase() > b.text.toLowerCase()) return 1;
      return 0;
    });
  };

  const handleOnSelection = (newValue: MultipleSelectionDropdownOptions[]) => {
    const eventInstructorRole: EventStatus[] = newValue.map(x => EventStatus[x.id]);
    onChange(eventInstructorRole);
  };

  const [options] = useState<MultipleSelectionDropdownOptions[]>(getAllEventStatus());

  return (
    <TailwindMultiSelect
      options={options.map(status => ({
        id: status.id,
        text: status.text
      }))}
      value={(value || []).map(x => ({
        id: EventStatus[x],
        text: x
      }))}
      onChange={handleOnSelection}
      placeholder={placeholder || t('Select requests status')}
      clearable={clearable}
      disabled={disabled}
      className={className}
      onBlur={onBlur}
      onFocus={onFocus}
      searchable
    />
  );
};

// Wire up the React component to the Redux store
export default withTranslation()(TailwindMultipleEventStatusEditor);
